import { useFormContext, useWatch } from "react-hook-form";

import { Paper, Stack, Typography } from "@mui/material";

import { useEffect } from "react";
import { formatMoney } from "../../../shared";

export const PriceSummarySection = () => {
  const { control, setValue } = useFormContext();
  const salesInvoicePayments = useWatch({
    control,
    name: "salesInvoicePayments",
  });

  const subtotal =
    salesInvoicePayments?.reduce(
      (acc, payment) => acc + payment.allocatedAmount,
      0
    ) || 0;

  const totalDiscount =
    salesInvoicePayments?.reduce((acc, payment) => acc + payment.discount, 0) ||
    0;

  const grandTotal = subtotal - totalDiscount;

  useEffect(() => {
    setValue("grandTotal", grandTotal);
  }, [grandTotal, setValue]);

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Stack spacing={1}>
        {/* Subtotal Display */}
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          <Typography variant="body2">Subtotal</Typography>
          <Typography variant="body2">{formatMoney(subtotal)}</Typography>
        </Stack>

        {/* Total Discount Display */}
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          <Typography variant="body2">Total Diskon</Typography>
          <Typography variant="body2">{formatMoney(totalDiscount)}</Typography>
        </Stack>

        {/* Grand Total Display */}
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          <Typography sx={{
            fontWeight: "bold"
          }}>Grand Total</Typography>
          <Typography sx={{
            fontWeight: "bold"
          }}>{formatMoney(grandTotal)}</Typography>
        </Stack>
      </Stack>
    </Paper>
  );
};
